import { render, staticRenderFns } from "./PlatformAnalyticsView.vue?vue&type=template&id=c329eeee&scoped=true"
import script from "./PlatformAnalyticsView.vue?vue&type=script&lang=js"
export * from "./PlatformAnalyticsView.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalyticsView.vue?vue&type=style&index=0&id=c329eeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c329eeee",
  null
  
)

export default component.exports